import Controller from "./paymentMethods.controller";
import template from "./paymentMethods.html";

const paymentMethods = {
  template,
  controller: Controller,
  bindings: {
    payments: "<",
  },
};

export default paymentMethods;



// WEBPACK FOOTER //
// ./src/components/paymentMethods/paymentMethods.component.js